// Calendário de dias úteis do SLA (issue #1760), espelho do helper business-days
// dos serviços: segunda a sexta fora de feriado nacional. Feriados estaduais e
// municipais ficam fora; 24/12 e 31/12 são dias úteis. Só o dia civil importa,
// no calendário local do navegador.

// Feriados nacionais fixos: [mês, dia].
const FIXED_HOLIDAYS = [
  [1, 1], // Confraternização Universal
  [4, 21], // Tiradentes
  [5, 1], // Dia do Trabalho
  [9, 7], // Independência
  [10, 12], // Nossa Senhora Aparecida
  [11, 2], // Finados
  [11, 15], // Proclamação da República
  [11, 20], // Consciência Negra
  [12, 25], // Natal
];

// Feriados móveis, em dias a partir do Domingo de Páscoa.
const EASTER_OFFSETS = [
  -48, // Carnaval (segunda)
  -47, // Carnaval (terça)
  -46, // Quarta-feira de Cinzas
  -2, // Sexta-feira Santa
  60, // Corpus Christi
];

const holidaysByYear = new Map();

function isValidDate(date) {
  return date instanceof Date && !Number.isNaN(date.getTime());
}

function dayKey(date) {
  return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
}

// Domingo de Páscoa no calendário gregoriano (algoritmo de Meeus/Jones/Butcher).
export function easterSunday(year) {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(year, month - 1, day);
}

function nationalHolidays(year) {
  let holidays = holidaysByYear.get(year);
  if (!holidays) {
    holidays = new Set();
    for (const [month, day] of FIXED_HOLIDAYS) {
      holidays.add(dayKey(new Date(year, month - 1, day)));
    }
    const easter = easterSunday(year);
    for (const offset of EASTER_OFFSETS) {
      holidays.add(dayKey(new Date(easter.getFullYear(), easter.getMonth(), easter.getDate() + offset)));
    }
    holidaysByYear.set(year, holidays);
  }
  return holidays;
}

export function isNationalHoliday(date) {
  return isValidDate(date) && nationalHolidays(date.getFullYear()).has(dayKey(date));
}

export function isBusinessDay(date) {
  if (!isValidDate(date)) return false;
  const weekDay = date.getDay(); // 0 = domingo, 6 = sábado
  return weekDay !== 0 && weekDay !== 6 && !isNationalHoliday(date);
}

// Conta os dias úteis depois de `from` até `to`, inclusive. Zero quando `to`
// não é posterior a `from`. Só o dia civil de cada data é considerado.
export function countBusinessDaysUntil(from, to) {
  if (!isValidDate(from) || !isValidDate(to)) return 0;
  const cursor = new Date(from.getFullYear(), from.getMonth(), from.getDate());
  const end = new Date(to.getFullYear(), to.getMonth(), to.getDate());
  let count = 0;
  while (cursor < end) {
    cursor.setDate(cursor.getDate() + 1);
    if (isBusinessDay(cursor)) count++;
  }
  return count;
}
